/* @flow */
import type { Action, AsyncAction, MediaSearchFullParams } from '../../types';

import liferay from '../../services/liferay';

const onFailure = (error: Object) => console.warn(error);

const setNewsSearch = (params: MediaSearchFullParams): Action => {
  return {
    type: 'SET_NEWS_SEARCH',
    payload: params,
  };
};

const performNewsSearch = (params: MediaSearchFullParams): AsyncAction => {
  //$FlowFixMe
  return {
    type: 'PERFORM_NEWS_SEARCH_REQUEST',
    payload: params,
    promise: liferay.medias.find(params),
    meta: { onFailure },
  };
};

const fetchNewsSearchPage = (params: MediaSearchFullParams): AsyncAction => {
  //$FlowFixMe
  return {
    type: 'FETCH_NEWS_SEARCH_PAGE_REQUEST',
    payload: params,
    promise: liferay.medias.find(params),
    meta: { onFailure },
  };
};

const newsSearchSetPageScroll = (pageScroll: number): Action => {
  return {
    type: 'NEWS_SEARCH_SCROLL_PAGE',
    payload: pageScroll,
  };
};

const newsSearchToggleExpandCategory = (categoryId: number): Action => {
  return {
    type: 'NEWS_SEARCH_TOGGLE_EXPAND_CATEGORY',
    payload: categoryId,
  };
};

const newsSearchSetCategorySlide = (categoryId: number, slideIndex: number): Action => {
  return {
    type: 'NEWS_SEARCH_SET_CATEGORY_SLIDE',
    payload: {
      categoryId,
      slideIndex,
    },
  };
};

export default {
  setNewsSearch,
  performNewsSearch,
  fetchNewsSearchPage,
  newsSearchToggleExpandCategory,
  newsSearchSetPageScroll,
  newsSearchSetCategorySlide,
};
